import SidePanelHeader from "../components/SidePanelHeader"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import { formatAddressString } from "../../../../../helpers/StringHelper";
import SidePanelAccessTokens from "../components/SidePanelAccessTokens";
import ActionBar from "../actions/ActionBar";
import EditAction from "../actions/EditAction";
import DeleteAccountAction from "../actions/DeleteAccountAction";
import CancelAccountAction from "../actions/CancelAccountAction";
import { hasAccountBasedPermission, hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { hasVisibleChildren } from "../../../entityComponents/Schema";
import FileDownloadWidget from "../../../FileDownloadWidget";
import { EntityNames } from "../../../../../enums/EntityNames";
import { AccountStatusSmartEnum } from "../../../../../enums/Domain/AccountStatusSmartEnum";


export default function SidePanelAccounts({ data, onViewPage }: any) {
    const navigate = useNavigate()
    const permissionsContext = usePermissions();

    function viewEntity() {
        // Only navigate if there are visible children
        if (hasVisibleChildren(data.entityName, permissionsContext)) {
            Navigation.view.navigate(navigate, data.entityName, data.id, data)
        }
    }

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="" value={data.name} statuses={data.status} onClick={(() => { viewEntity() })} cantNavigate={hasVisibleChildren(data.entityName, permissionsContext) === false} />}
                <ActionBar>
                    {hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.Inventory_Reports) &&
                        <FileDownloadWidget
                            id={data.id}
                            entityName={EntityNames.inventoryExports}
                            buttonText="Download Inventory"
                            loadingText="Downloading"
                            queryParamName="accountId"
                        />
                    }
                    {hasAccountBasedPermission(data.id, permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Edit_Account, permissionsContext.cellTrakOperatorClaim) && <EditAction id={data.id} entityName={data.entityName} />}
                    {hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Permanent_Account_Removal) && 
                        (data.status?.value === AccountStatusSmartEnum.PendingDeletion.value ? 
                            <CancelAccountAction data={data} /> : 
                            <DeleteAccountAction data={data} />
                        )
                    }
                </ActionBar>
                <SidePanelInfo
                    values={[
                        { label: "Active Users", value: data.activeUsersCount },
                        { label: "Name", value: data.name },
                        { label: "Customer", value: data.customerName },
                        { label: "Address", value: formatAddressString(data.address), classname: "whitespace--pre-line" }
                    ].filter(x => x.value !== undefined && x.value !== null && x.value !== "")}
                />
                {hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.Account_Users) &&
                    <SidePanelInfo
                        values={[
                            { label: "Telephone", value: data.contactDetails.telephone },
                            { label: "Mobile", value: data.contactDetails.mobile },
                            { label: "Fax", value: data.contactDetails.fax },
                            { label: "Email", value: data.contactDetails.email },
                        ].filter(x => x.value)}
                    />
                }
                {hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Manage_API_Access) &&
                    <SidePanelAccessTokens id={data.id} entityName="accountAccessToken" />
                }
            </>
        }
    </>)
}